import React from 'react'
import { ArrowRightOutlined, RobotOutlined } from '@ant-design/icons'
import { useFormContext } from '@/state/main-form/reducer'
import { SITE_NAME } from '@/utils/constants'
import style from './top-bar.module.sass'

type Props = {
	setChatOpen: (chatOpen: boolean) => void
}

export const TopBar = ({ setChatOpen }: Props) => {
	const formContext = useFormContext()
	return (
		<div className={style.container}>
			<div className={style.leftContent}>
				<div className={style.agentLogo}>
					<RobotOutlined />
				</div>
				<div className={style.nameContainer}>
					<div className={style.agentName}>
						{SITE_NAME.charAt(0).toUpperCase() + SITE_NAME.slice(1).toLowerCase()} Assistant
					</div>
					<div className={style.description}>{formContext.form.title}</div>
				</div>
			</div>

			<div className={style.closeButton} onClick={() => setChatOpen(false)}>
				<ArrowRightOutlined />
			</div>
		</div>
	)
}
